import { createRoot } from 'react-dom/client';
import { AppProviders } from './app/providers';
import { clearCacheOnStartup } from '@sphere/shared/util';
import './carbon.scss';
import './index.css';

clearCacheOnStartup();

createRoot(document.getElementById('root')!).render(<AppProviders />);
